import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { healthArticles } from '../data/sampleData';

const BlogDetail = () => {
  const { id } = useParams();
  const article = healthArticles.find(a => a.id === parseInt(id)) || healthArticles[0];

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-6">
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
          <img src={article.image} alt={article.title} className="w-full h-96 object-cover" />
          <div className="p-8">
            <div className="flex items-center gap-3 mb-4">
              <span className="px-3 py-1 bg-[#39a5d3]/10 text-[#39a5d3] text-sm font-semibold rounded-full">
                {article.category}
              </span>
              <span className="text-sm text-gray-600">{article.readTime}</span>
              <span className="text-sm text-gray-600">{article.date}</span>
            </div>
            
            <h1 className="text-4xl font-bold text-[#19354a] mb-4">{article.title}</h1>
            
            <div className="flex items-center gap-3 mb-6 pb-6 border-b">
              <span className="text-gray-700">By {article.author}</span>
            </div>

            <div className="prose max-w-none text-gray-700 leading-relaxed">
              <p className="mb-4">{article.excerpt}</p>
              <p className="mb-4">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.
              </p>
              <p className="mb-4">
                Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
              </p>
            </div>

            <div className="mt-8 pt-6 border-t">
              <Link to="/blog" className="text-[#39a5d3] hover:underline">
                ← Back to all articles
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetail;
